<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button class="btn-primary" size="small" icon="el-icon-plus" @click="showDialog()" v-if="permission.add">{{ permission.add }}</el-button>
            </div>
        </div>
        <div class="table-ctn address-table">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column prop="Name" label="角色名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="StaffName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="120px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button size="mini" title="分配权限" v-if="permission.auth" @click="showAuthDialog(scope.row)">
                                <i class="fa fa-gears"></i>
                            </el-button>
                            <el-button size="mini" @click="editRoles(scope.row)" v-if="permission.edit">
                                <i class="el-icon-edit-outline"></i>
                            </el-button>
                            <el-button size="mini" type="danger" @click="delRoles(scope.row)" v-if="permission.del">
                                <i class="el-icon-delete"></i>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                :title="dialogTitle"
                :before-close="clearDialog"
                :visible.sync="dialogVisible"
                custom-class="base-dialog"
                width="500px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <div class="form-main">
                        <el-form ref="rolesEdit" label-width="110px" class="formData">
                            <el-form-item label="角色名称">
                                <el-input v-model.trim="roleName" v-filter-special-char="roleName"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="dialog-footer">
                            <el-button class="btn-primary" @click="submitForm">提交</el-button>
                            <el-button @click="clearDialog">取消</el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <!-- 弹窗 -->
            <el-dialog
                :append-to-body="true"
                :close-on-click-modal="false"
                :before-close="closeDialog"
                title="为角色分配权限"
                :visible.sync="dialogAuthVisible"
                custom-class="base-dialog"
                width="1000px"
                v-loading.fullscreen="false"
            >
                <div class="dialog-content">
                    <!--  分配权限  -->
                    <template>
                        <div class="permission-ctn">
                            <div class="permission-tree">
                                <el-tree
                                    ref="tree"
                                    :check-strictly="true"
                                    :data="treeData"
                                    :props="defaultProps"
                                    :expand-on-click-node="false"
                                    show-checkbox
                                    node-key="Id"
                                    default-expand-all
                                    :default-checked-keys="checkedTree"
                                    @check="handleNodeChecked"
                                >
                                    <div class="custom-tree-node" slot-scope="{ node, data }">
                                        <span class="element-name" :class="{ lv3: node.level == 3 }">{{ data.Name }}</span>
                                        <span class="element-ops">
                                            <span v-for="item in data.Elements" :key="item.Id">
                                                <input type="checkbox" v-bind:value="item.Id" v-model="selelementsId" @change="checkElem($event, item, node)" />
                                                {{ item.Name }}
                                            </span>
                                        </span>
                                    </div>
                                </el-tree>
                            </div>
                        </div>
                    </template>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            booleanTrue: true,
            booleanFalse: false,
            areaSelect: [], // 地址三级联动
            dialogVisible: false,
            dialogTitle: '编辑角色', //dialog标题
            searchData: {
                page: 1, // 当前页数
                limit: 15, // 每页限制条数
                key: '' //关键字查询
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            dialogAuthVisible: false,
            isLoading: false,
            treeData: [], //模块树数据集
            checkedTree: [], //已选中的树节点
            selelementsId: [], //已选中的按钮
            defaultProps: {
                children: 'Children',
                label: 'Name'
            },
            parentsData: [], // 遍历出的父节点列表
            assignPermissions: [],
            perRoleId: '',
            roleName: ''
        };
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('RoleManange');
    },
    methods: {
        loadData() {
            this.getTableData();
            this.clearDialog();
        },
        clearDialog() {
            this.dialogVisible = false;
            this.roleName = '';
            this.roleId = '';
        },
        // 获取数据
        getTableData() {
            this.dialogVisible = false;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetRoleList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        // 编辑地址
        editRoles(data) {
            this.roleName = data.Name;
            this.roleId = data.Id;
            this.dialogTitle = '编辑角色';
            this.dialogVisible = true;
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        // 显示dialog
        showDialog() {
            this.roleName = '';
            this.roleId = '';
            this.dialogTitle = '新增角色';
            this.dialogVisible = true;
        },
        showAuthDialog(item) {
            this.perRoleId = '';
            this.$util
                .axiosGet({
                    url: '/api/Permission/GetCheckedRoleModulesIds',
                    data: {
                        roleId: item.Id
                    }
                })
                .then(res => {
                    this.checkedTree = res.data.selmodulesId;
                    this.selelementsId = res.data.selelementsId;
                    this.perRoleId = item.Id;
                    if (!this.treeData || this.treeData.length == 0) {
                        this.getPermission();
                    }
                    this.dialogAuthVisible = true;
                });
        },
        // 删除地址
        delRoles(data) {
            let that = this;

            this.$util.elConfirm({
                content: '确定要删除该角色吗？',
                confirm() {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpInfoManagement/DeleteRoles',
                            data: {
                                roleId: data.Id
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) that.getTableData();
                        })
                        .catch(() => {
                            this.dialogLoadingShow = false;
                            this.assignPermissions = [];
                        });
                }
            });
        },
        // 弹窗关闭前清空验证
        closeDialog() {
            if (this.$refs.tree) {
                this.$refs.tree.setCheckedKeys([]);
            }
            this.checkedTree = [];
            this.selelementsId = [];
            this.dialogAuthVisible = false;
        },
        // 勾选模块
        handleNodeChecked(data, node) {
            this.assignPermissions = [];
            this.parentsData = [];
            let parentNode = this.$refs.tree.getNode(data.Id);
            if (parentNode) {
                this.getParentsNames(parentNode, []);
            }
            let _checkedTree = this.$refs.tree.getCheckedKeys();
            let flag = false;
            for (let i = 0; i < _checkedTree.length; i++) {
                if (_checkedTree[i] == data.Id) {
                    flag = true;
                    break;
                }
            }
            if (flag) {
                this.checkTreeNoHttp(data, true);
                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({ key: 'RoleModule', secId: item.key });
                    }
                });
                this.AssignPermission();
            } else {
                this.checkTreeNoHttp(data, false);
                this.UnAssignPermission();
            }
        },
        checkTreeNoHttp(node, checked) {
            this.$refs.tree.setChecked(node.Id, checked, 'deep');
            this.assignPermissions.push({ key: 'RoleModule', secId: node.Id });
            let that = this;
            //设置菜单下按钮是否选中
            node.Elements.forEach((x, index) => {
                that.assignPermissions.push({ key: 'RoleElement', secId: x.Id });
                if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                    that.selelementsId.push(x.Id);
                } else {
                    for (let i = 0; i < that.selelementsId.length; i++) {
                        if (that.selelementsId[i] == x.Id) {
                            that.selelementsId.splice(i, 1);
                            return true;
                        }
                    }
                }
            });
            //循环节点子级
            for (let i = 0; i < node.Children.length; i++) {
                that.$refs.tree.setChecked(node.Children[i].Id, checked, 'deep');
                that.assignPermissions.push({
                    key: 'RoleModule',
                    secId: node.Children[i].Id
                });
                //设置菜单下按钮是否选中
                node.Children[i].Elements.forEach((x, index) => {
                    that.assignPermissions.push({ key: 'RoleElement', secId: x.Id });
                    if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                        that.selelementsId.push(x.Id);
                    } else {
                        for (let i = 0; i < that.selelementsId.length; i++) {
                            if (that.selelementsId[i] == x.Id) {
                                that.selelementsId.splice(i, 1);
                                return true;
                            }
                        }
                    }
                });
                //递归
                if (node.Children[i].Children[0]) {
                    that.checkTreeNoHttp(node.Children[i], checked);
                }
            }
        },
        //勾选权限操作按钮
        checkElem(event, data, node) {
            this.parentsData = [];
            this.getParentsNames(node, []);
            this.assignPermissions = [];
            this.assignPermissions.push({ key: 'RoleElement', secId: data.Id });
            if (event.target.checked) {
                if (this.selelementsId.indexOf(data.Id) == -1) {
                    this.selelementsId.push(data.Id);
                }

                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({ key: 'RoleModule', secId: item.key });
                    }
                });

                this.AssignPermission();
            } else {
                let i = this.selelementsId.findIndex(item => {
                    if (item == data.Id) {
                        return true;
                    }
                });
                if (i > -1) {
                    this.selelementsId.splice(i, 1);
                }
                this.UnAssignPermission();
            }
        },
        // 递归获取未选中父级列表
        getParentsNames(obj, result) {
            if (obj.key) {
                if (!obj.checked) {
                    result.push({
                        key: obj.key,
                        label: obj.label
                    });
                }
                this.getParentsNames(obj.parent, result);
            } else {
                this.parentsData = result;
            }
        },
        //分配权限
        AssignPermission() {
            this.dialogLoadingShow = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/AssignPermission',
                    data: {
                        firstId: this.perRoleId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.dialogLoadingShow = false;
                    this.$util.successMsg('分配权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.dialogLoadingShow = false;
                    this.assignPermissions = [];
                });
        },
        // 取消权限分配
        UnAssignPermission() {
            this.dialogLoadingShow = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/UnAssignPermission',
                    data: {
                        firstId: this.perRoleId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.dialogLoadingShow = false;
                    this.$util.successMsg('取消权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.dialogLoadingShow = false;
                    this.assignPermissions = [];
                });
        },
        // 获取模块树接口
        getPermission() {
            this.$util
                .axiosGet({
                    url: '/api/Permission/GetEntpModulesTree'
                })
                .then(res => {
                    let data = res.data;
                    this.treeData = data;
                });
        },
        submitForm() {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/EditRoles',
                    data: {
                        Name: that.roleName,
                        Id: that.roleId
                    }
                })
                .then(() => {
                    that.getTableData();
                });
        }
    }
};
</script>
<style lang="less" scoped>
.address-table .el-table .el-table__body .el-table__row .cell button {
    padding: 3px 7px !important;
}
.dialog-content {
    max-height: 800px;
}
.base-content {
    max-width: 1200px;
    margin: 0 auto;
}
.search-ctn {
    margin-bottom: 10px;
}
.permission-ctn {
    display: flex;
}
.dialog-content {
    overflow-x: auto;
    position: relative;
    overflow: auto;
}
.root-checkbox {
    width: 14px;
    height: 14px;
    background: white;
}
.root-checkbox-ctn {
    display: flex;
    align-items: center;
}
.permission-tree {
    // width: 100%;
    // overflow-y: scroll;会影响x轴滚动条的展现
    height: 460px;
    padding-bottom: 50px;
}
.lv3 {
    width: 132px !important;
}
.shrink-out-view {
    background-color: rgba(0, 0, 0, 0.075);
    display: flex;
    align-items: center;
    cursor: pointer;
}
.shrink-in-view {
    width: 100%;
    height: 30px;
    background-color: #409eff;
    border-radius: 7px;
    text-align: center;
    display: flex;
    align-items: center;
    color: #fff;
}
.shrink-in-view .active {
    transform: rotate(-180deg);
}
</style>
